import styles from "./Sidebar.module.scss";
import BrandLogo from "../../resources/images/ats-icon.svg";
import BrandIcon from "../../resources/images/ats-icon.svg";
import { MdLogout } from "react-icons/md";
import { SlBriefcase } from "react-icons/sl";
import { AiOutlinePieChart, AiOutlineSetting } from "react-icons/ai";
import { FiExternalLink, FiUserCheck } from "react-icons/fi";
import { TbBellRinging, TbUsers } from "react-icons/tb";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { authActions } from "../../actions/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { checkLogin } from "../../helpers";
import { NotificationActions, ResourceActions } from "../../actions";
import { RiUserSharedLine } from "react-icons/ri";

function Sidebar() {
  const [isCollapse, setCollapse] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.authentication.user);
  const userProfile = useSelector((state) => state.authentication.userProfile);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (userProfile && userProfile?.favicon?.url) {
      setLoading(false)
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = userProfile?.favicon?.url;
    }else{
      if(userProfile && userProfile?.companyLogo == null){
      setLoading(false);
      }
    }

  }, [userProfile]);

  const notificationCount = useSelector(
    (state) => state.notification.unreadNotification
  );
  const logout = () => {
    dispatch(authActions.logout());
    navigate(0)
  };
  useEffect(() => {
    checkLogin(navigate);
    dispatch(authActions.getProfile())
    dispatch(NotificationActions.getUnreadNotification());
    dispatch(ResourceActions.getEnumData())

    if (window.innerWidth < 576) {
      setCollapse(true)
    }
  }, []);

  useEffect(() => {
    if (notificationCount && notificationCount > 0) {
      setUnreadCount(notificationCount);
    } else {
      if (notificationCount === 0) {
        setUnreadCount(0);
      }
    }
  }, [notificationCount]);
  return (
    <div
      className={
        !isCollapse
          ? styles.sidebarMain
          : `${styles.sidebarMainCollapsed} close-sidedbar`
      }
    >
      <div className={styles.sidebar}>

        <div className="navBarTop">
          <div className={styles.brandLogo}>
            {
              !loading ?
                <>  {userProfile  && userProfile?.companyLogo?.url  ?
                  <img
                    src={userProfile?.companyLogo?.url }
                    alt={userProfile?.companyLogo?.name }
                    width={isCollapse ? 60 : 90}
                    className="img-fluid brnadlogo"
                  /> : <img
                    src={isCollapse ? BrandIcon : BrandLogo}
                    alt="brnadlogo"
                    className="img-fluid"
                  />
                }</> : <></>
            }

          </div>
          <NavLink
            to="/applicants"
            className={(data) => "" + (data.isActive ? styles.active : "")}
          >
            <div className={`${styles.navLink}`}>
              <span className={styles.navIcon}>
                <TbUsers />
              </span>
              {!isCollapse && (
                <>
                  <span className={`${styles.navLable}`} id="applicant">
                    Applicants
                  </span>
                </>
              )}
            </div>
          </NavLink>
          {user && user.userRole ? (
            <>
              {/* <NavLink
                to="/"
                className={(data) => "" + (data.isActive ? styles.active : "")}
              >
                <div className={`${styles.navLink}`}>
                  <span className={styles.navIcon}>
                    <ColumnsGap />
                  </span>
                  {!isCollapse && (
                    <>
                      <span className={`${styles.navLable}`} id="dashboard">
                        Dashboard
                      </span>
                    </>
                  )}
                </div>
              </NavLink> */}
              <NavLink
                to="/openings"
                className={(data) => "" + (data.isActive ? styles.active : "")}
              >
                <div className={`${styles.navLink}`}>
                  <span className={styles.navIcon}>
                    <SlBriefcase />
                  </span>
                  {!isCollapse && (
                    <>
                      <span className={`${styles.navLable}`} id="openings">
                        Openings
                      </span>
                    </>
                  )}
                </div>
              </NavLink>
            </>
          ) : (
            ""
          )}


          <NavLink
            to="/alerts"
            className={(data) => "" + (data.isActive ? styles.active : "")}
          >
            <div className={`${styles.navLink}`}>
              <span className={styles.navIcon}>
                <TbBellRinging />
              </span>
              {!isCollapse && (
                <>
                  <span className={`${styles.navLable}`} id="alerts">
                    Alerts
                    {unreadCount && unreadCount > 0 ? (
                      <span className={styles.Notibadge}>{unreadCount}</span>
                    ) : (
                      ""
                    )}
                  </span>
                </>
              )}
            </div>
          </NavLink>
          {user && user.userRole === 1 ? (
            <NavLink
              to="/master-data"
              className={(data) => "" + (data.isActive ? styles.active : "")}
            >
              <div className={`${styles.navLink}`}>
                <span className={styles.navIcon}>
                  <AiOutlinePieChart />
                </span>
                {!isCollapse && (
                  <>
                    <span className={`${styles.navLable}`} id="masterData">
                      Master Data
                    </span>
                  </>
                )}
              </div>
            </NavLink>
          ) : (
            ""
          )}

            <NavLink
              to="/referral-profile"
              className={(data) => "" + (data.isActive ? styles.active : "")}
            >
              <div className={`${styles.navLink} d-flex`}>
                <span className={`${styles.navIcon} py-0`}>
                  <RiUserSharedLine />
                </span>
                {!isCollapse && (
                  <>
                    <p className={`${styles.navLable} m-0`} id="masterData">
                      Non Opening Referrals
                    </p>
                  </>
                )}
              </div>
            </NavLink>
          

          {localStorage.getItem('domain') || user && user?.domain && user?.userRole !== 4 ?
            <a
              href={`https://${localStorage.getItem('domain') ? localStorage.getItem('domain') : user?.domain}/careers`}
              target="_blank"
              className={(data) => "" + (data.isActive ? styles.active : "")}
            >
              <div className={`${styles.navLink}`}>
                <span className={styles.navIcon}>
                  <FiExternalLink />
                </span>
                {!isCollapse && (
                  <>
                    <span className={`${styles.navLable}`} id="career">
                      Careers
                    </span>
                  </>
                )}
              </div>
            </a> : ""
          }


        </div>

        <div className="navBarBottom">
          <NavLink
            to="/settings"
            className={(data) => "" + (data.isActive ? styles.active : "")}
          >
            <div className={`${styles.navLink}`}>
              <span className={styles.navIcon}>
                <AiOutlineSetting />
              </span>
              {!isCollapse && (
                <>
                  <span className={`${styles.navLable}`} id="settings">
                    Settings
                  </span>
                </>
              )}
            </div>
          </NavLink>

          <div
            className={`${styles.navLinkEnd}  `}
            onClick={() => {
              logout();
            }}
          >
            <span className={styles.navIcon}>
              <MdLogout />
            </span>
            {!isCollapse && (
              <span className={`${styles.navLable}`}>Logout</span>
            )}
          </div>
        </div>

        <span
          className={!isCollapse ? styles.badge : styles.badgee}
          onClick={() => {
            setCollapse(!isCollapse);
          }}
        >
          {isCollapse ? <ChevronRight /> : <ChevronLeft />}
        </span>
      </div>
    </div>
  );
}

export default Sidebar;
